module.exports = __webpack_public_path__ + "media/images/item-placeholder-4eb9957d8c1cdc8478b6d88e44ed8595.jpg";